import {useSearchParams, useNavigate} from "react-router-dom";
import {sendLog} from "../functions/common/SendLog";
import {useEffect, useRef, useMemo} from "react";
import {ServerApi} from "../api/ServerApi";

//Страница №3
//Перенаправление на страницу авторизации госУслуг (Получение данных)
export default function GetEsiaData() {
    const hasProcessed = useRef(false);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const title = "Страница 3. Перенаправление на страницу авторизации госУслуг. Получение данных";
    const docSessionCode = localStorage.getItem("doc_session_code");
    const appDebag = localStorage.getItem("app_debag");
    const serverApi = useMemo(() => new ServerApi(), []);
    const esiaError = searchParams.get("error");
    const esiaCode = searchParams.get("code");

    useEffect(() => {
        if (hasProcessed.current) return;

        const handleEsiaFlow = async () => {
            if (esiaError) {
                hasProcessed.current = true;
                sendLog(serverApi, title, 'К сожалению, возникла проблема при попытке загрузить данные.', '', true, {error: esiaError});
                navigate('/', {
                    state: {error: ['К сожалению, возникла проблема при попытке загрузить данные', 'Попробуйте позже']},
                });
                return;
            }

            if (esiaCode) {
                try {
                    hasProcessed.current = true;
                    const appLogicType = localStorage.getItem('app_logic_type');

                    const response = await serverApi.setEsiaData(docSessionCode, esiaCode, appDebag, appLogicType);

                    if (response?.data?.success) {
                        sendLog(serverApi, title, 'Получение данных от ЕСИА по коду', 'setEsiaData', false, response);

                        if (Number(appLogicType) === 2) {
                            try {
                                const completeRes = await serverApi.completeData(docSessionCode, appDebag);
                                //console.log(completeRes);

                                if (completeRes?.data?.success) {
                                    sendLog(serverApi, title, 'Финализация статуса и отправка данных ЕСИА заказчику', 'completeData ', false, completeRes);
                                    navigate("/signed");
                                } else {
                                    sendLog(serverApi, title, 'Финализация статуса и отправка данных ЕСИА заказчику', 'completeData ', true, completeRes?.data?.error);
                                    navigate('/', {
                                        state: {error: completeRes?.data?.error || ['Ошибка финального статуса 2']}
                                    });
                                }
                            } catch (error) {
                                sendLog(serverApi, title, 'Финализация статуса и отправка данных ЕСИА заказчику', 'completeData ', true, error);
                                navigate('/', {
                                    state: {error: ['Ошибка финального статуса 2', 'Попробуйте позже']}
                                });
                            }
                        } else {
                            // Если тип кейса 1, просто переходим на страницу документов
                            navigate("/doc");
                        }

                    } else {
                        sendLog(serverApi, title, 'Получение данных от ЕСИА по коду', 'setEsiaData', true, response?.data?.error);
                        navigate('/', {
                            state: {error: response?.data?.error},
                        });
                    }
                } catch (error) {
                    sendLog(serverApi, title, 'Получение данных ЕСИА по коду', 'setEsiaData', true, error);
                    navigate('/', {
                        state: {error: ['Ошибка получения данных', 'Попробуйте позже']},
                    });
                }
            }
        };

        handleEsiaFlow();
    }, [esiaCode, esiaError, navigate, docSessionCode, serverApi, title]);

    return (
        <div id={"main-page-wrapper"}>
            <div className={"justify-content-center"} id={"sign_loader"}>
                <div>
                    <h4 className={"text-center loader-text"}>
                        Получение данных
                    </h4>
                    <div className={"progress ms-2"}>
                        <div className={"progress-bar h-100"}>
                            <div className={"progress-shadow"}></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
